<template>
    <div class="main-div" :class="width">
        <div class="header-div">
            <div class="title-div">
                <div class="icon-text-header">
                    <div class="icon-div">
                        <svg xmlns="http://www.w3.org/2000/svg" width="380" height="380" viewBox="0 0 480 480" fill="none" class="pattern" opacity="0.4">
                            <defs>
                                <clipPath id="clip-circle">
                                    <rect x="190" y="190" width="240" height="240" />
                                </clipPath>
                            </defs>
                            <g clip-path="url(#clip-circle)">
                                <circle cx="240" cy="240" r="60" stroke="#E4E4E7" />
                                <circle cx="240" cy="240" r="92" stroke="#E4E4E7" />
                                <circle cx="240" cy="240" r="124" stroke="#E4E4E7" />
                                <circle cx="240" cy="240" r="156" stroke="#E4E4E7" />
                            </g>
                        </svg>
                        <slot name="icon" />
                    </div>
                    <div>
                        <div class="title-section">
                            <p>{{ title }}</p>
                        </div>
                        <p class="sub-title">{{ subtitle }}</p>
                    </div>
                </div>
                <div class="title-wrapper" :class="bodyClass">
                    <div class="divider" :class="dividerClass"></div>
                    <slot />
                </div>
            </div>
        </div>
        <div v-if="$slots.footer" class="modal-footer" :class="footerClass">
            <div class="footer-actions">
                <slot name="footer" />
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
withDefaults(
    defineProps<{
        title: string;
        subtitle: string;
        width?: string;
        bodyClass?: string;
        dividerClass?: string;
        footerClass?: string;
    }>(),
    {
        width: 'sm:max-w-xl sm:w-full w-11/12',
        bodyClass: 'gap-1',
        dividerClass: 'mt-4 mb-3.5',
        footerClass: 'pt-8',
    }
);
</script>
<style lang="scss" scoped>
.main-div {
    @apply rounded-lg bg-white mx-auto h-auto overflow-y-auto;
}
.header-div {
    @apply flex flex-row items-start gap-4 self-stretch;
}
.title-div {
    @apply flex flex-col p-6 pb-0 items-start gap-1 self-stretch w-full;
}
.icon-text-header {
    @apply flex flex-row items-start gap-4 w-full;
}
.icon-div {
    @apply relative flex w-12 h-12 p-3 justify-center items-center rounded-full bg-gray-100 flex-shrink-0;
}
.pattern {
    @apply absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none;
}
.title-section {
    @apply self-stretch flex flex-row justify-between relative;

    p {
        @apply text-zinc-950 font-inter text-lg font-semibold leading-7;
    }
}
.sub-title {
    @apply text-zinc-600 font-inter text-sm font-normal leading-5;
}
.title-wrapper {
    @apply flex flex-col items-start sm:flex-1 sm:w-auto w-full sm:pl-16;
}
.divider {
    @apply h-px bg-zinc-300 w-full;
}
.modal-footer {
    @apply flex flex-col justify-center items-end self-stretch;

    .footer-actions {
        @apply flex justify-end items-center gap-3 flex-1 px-6 pb-6;
    }
}
</style>
